export default {
    imageDashboardSummary: {
        totalImagesGenerated: "Total d'images générées",
        cost: 'Coût',
        imagesPerDay: 'Images/jour',
    },
};
